import axios from "axios";
import * as API_LINKS from '../config/links.jsx'
import {toast} from 'react-toastify'

export const FETCH_USER_TABLE = 'FETCH_USER_TABLE'
export const RECEIVE_USER_TABLE = 'RECEIVE_USER_TABLE'
export const FAILED_USER_TABLE = 'FAILED_USER_TABLE'

export function fetchUserTable(){

    return (dispatch, getState) => {
        
        let {authStore} = getState();
        let auth = null;
        if(authStore.authData){
            auth = authStore.authData.result.token;
        }
        dispatch({type: FETCH_USER_TABLE});
        axios({
            method: 'post',
            url: API_LINKS.USER_LIST_URL,
            headers: {
                Authorization: auth
            },
            data: {
                status : 0
            }
        })
        .then((response) => {
            // console.log(response.data)
            dispatch( {
                type: RECEIVE_USER_TABLE,
                payload: response.data
            })
            // console.log(response.data)
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_USER_TABLE
                    })
                    return toast.error(error.response.data.message);
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_USER_TABLE
                    })
                    return toast.error(error.response.data.message);
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_USER_TABLE
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_USER_TABLE
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_USER_TABLE
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_USER_TABLE
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}